import React from "react";
import Free_con from "../../assets/icons/FreeConsultation.png";
import Free_trial from "../../assets/icons/FreeTrial.png";
import DIY_reso from "../../assets/icons/DIYResources.png";
import case_stu from "../../assets/icons/CaseStudies.png";
import support from "../../assets/icons/Support.png";
import Easy_digital from "../../assets/icons/DigitalOnboarding.png";
import { CenteredTitleSubtitleContainer, SupportCard, SupportCardImg, SupportCardsContainer, SupportDescription, SupportImage, SupportSubtitle, SupportTitle, SupportTitleContainer } from "../../assets/styles/HomeStyles";


const SupportCards = () => {
  const cardsData = [
    { title: "Free Consultation", icon: Free_con, description: "Our experienced team offers free consultations to help identify your needs and design a custom program." },
    { title: "Free Trial", icon: Free_trial, description: "Try our services at no cost to assess our SLA and quality." },
    { title: "DIY Resources", icon: DIY_reso, description: "Access our guides and templates to conduct your own safety checks." },
    { title: "Case Studies", icon: case_stu, description: "Learn from our comprehensive case studies." },
    { title: "24x7 Support", icon: support, description: "Benefit from continuous customer support." },
    { title: "Easy Digital Onboarding", icon: Easy_digital, description: "Quickly onboard as a client through our streamlined digital process." }
  ];

  return (
    <>
      <CenteredTitleSubtitleContainer>
        <SupportTitleContainer>We Support All Businesses</SupportTitleContainer>
        <SupportSubtitle>
          iScreening is committed to helping you enhance your safety protocols, whether you're a current client or not.
        </SupportSubtitle>
      </CenteredTitleSubtitleContainer>

      <SupportCardsContainer>
        {cardsData.map((card, index) => (
          <SupportCard key={index}>
            <SupportCardImg>
              <SupportImage src={card.icon} alt={card.title} />
              <SupportTitle>{card.title}</SupportTitle>
            </SupportCardImg>
            <SupportDescription>{card.description}</SupportDescription>
          </SupportCard>
        ))}
      </SupportCardsContainer>
    </>
  );
};

export default SupportCards;
